// extracted by mini-css-extract-plugin
module.exports = {"login-page":"LoginPage-login-page--TJ2z-","alerts-box":"LoginPage-alerts-box--1GNis","modal-box":"LoginPage-modal-box--1StaD","notice-box":"LoginPage-notice-box--2vVTa"};